// removed by extract-text-webpack-plugin
module.exports = {"hint":"index__hint___1RwjA","selected":"index__selected____LZrE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/AssigneeModal/index.less
// module id = 969
// module chunks = 3